import i18next from 'i18next';

i18next.addResources('es', 'CardsNotifications', {
  notifyAllCards: 'Notificar todas las cédulas',
  notifyOnlyFavourites: 'Notificar sólo cédulas de expedientes favoritos',
  noNotify: 'No notificar cédulas'
});
